import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { VERSION as CDK_VERSION } from '@angular/cdk';
import { MAT_RIPPLE_GLOBAL_OPTIONS, VERSION as MAT_VERSION, MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import { provideServiceWorker } from '@angular/service-worker';

import { LOCALE_ID, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr, 'fr');
import { ClickOutsideDirective } from './shared/services/click-outside.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { CustomNgxDatetimeAdapter } from './shared/services/CustomNgxDatetimeAdapter';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { OAuthModule } from 'angular-oauth2-oidc';
import { jwtInterceptor } from './shared/services-interceptor/jwt.service';
import { errorInterceptor } from './shared/services-interceptor/error.service';
import { providePrimeNG } from 'primeng/config';
import D4MaterialPreset from '../assets/primeNgTheming';




const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: "l, LTS"
  },
  display: {
    dateInput: "l, LTS",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

console.info('Angular CDK version', CDK_VERSION.full);
console.info('Angular Material version', MAT_VERSION.full);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(ClickOutsideDirective),
    importProvidersFrom(MatDatepickerModule),
    importProvidersFrom(ScrollingModule),
    importProvidersFrom(MatNativeDateModule),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    providePrimeNG({
      theme: {
        preset: D4MaterialPreset,
        options: {
          darkModeSelector: false || 'none',
        }
      }
    }),
    importProvidersFrom(OAuthModule.forRoot()),
    provideAnimations(),
    provideOAuthClient(),
    provideHttpClient(withFetch(), withInterceptors([jwtInterceptor, errorInterceptor])),
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: false } },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    // {
    //   provide: NgxMatDateAdapter,
    //   useClass: CustomNgxDatetimeAdapter,
    //   deps: [MAT_DATE_LOCALE, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    // },
    { provide: DateAdapter, useClass: CustomNgxDatetimeAdapter, deps: [MAT_DATE_LOCALE] },
    // { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:9000',
    }),
  ],
};
